import type { CSSProperties } from 'react';
import { containFitScale } from '../../../infrastructure/runtime';
import '../components/atomic/layout/app_screen/app_screen.css';
import { GoBackButton } from '../components/atomic/buttons/go_back_button/GoBackButton';
import { GreenCtaButton } from '../components/atomic/buttons/green_cta_button/GreenCtaButton';
import { FrameHeader } from '../components/atomic/dialog/frame_header/FrameHeader';
import { SolidFrameBackground } from '../components/atomic/dialog/solid_frame_background/SolidFrameBackground';
import { SkyAtmosphere } from '../components/composite/atmosphere/sky_atmosphere/SkyAtmosphere';
import { useAppFit } from '../../hooks/useAppFit';
import ticketImg from '../components/atomic/icons/ticket/ticket.png';
import type { ScreenViewProps } from '../shared/screenViewProps';
import type { TaskDetailScreenController } from './TaskDetailScreenController';
import type { TaskDetailScreenModel } from './TaskDetailScreenModelScreen';
import './task_detail_screen.css';

export type TaskDetailScreenViewProps = ScreenViewProps<
  TaskDetailScreenModel,
  TaskDetailScreenController
>;

/** Detail card for a flight-ticket business task (CTA claim flow). */
export function TaskDetailScreenView({
  model,
  controller,
}: TaskDetailScreenViewProps) {
  const { content, actionInFlight } = model;
  const ctaDisabled = !content.actionEnabled || actionInFlight;
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  return (
    <div className="app-screen task-detail-screen">
      <SkyAtmosphere variant="delivery" />
      <div
        className="task-detail-plaques"
        style={
          {
            '--fit-contain-inv-x': String(contain.invX),
            '--fit-contain-inv-y': String(contain.invY),
            '--fit-contain-uniform': String(contain.uniform),
          } as CSSProperties
        }
      >
        <SolidFrameBackground />
        <FrameHeader showSubHeader={false} />

        <img
          className="task-detail-screen__title"
          src={content.titleSrc}
          alt={content.titleAlt}
          draggable={false}
        />

        <p className="task-detail-screen__body">{content.bodyText}</p>

        <div
          className="task-detail-screen__reward"
          aria-label={`Награда +${content.rewardPasses}`}
        >
          <span className="task-detail-screen__reward-plus">+</span>
          <span className="task-detail-screen__reward-value">
            {content.rewardPasses}
          </span>
          <img
            className="task-detail-screen__reward-ticket"
            src={ticketImg}
            alt=""
            draggable={false}
            aria-hidden
          />
        </div>

        {content.completed ? (
          <p className="task-detail-screen__status">Выполнено</p>
        ) : null}

        <GreenCtaButton
          className="task-detail-screen__cta"
          labelText={content.ctaLabel}
          ariaLabel={content.ctaLabel}
          onClick={controller.handleClaim}
          disabled={ctaDisabled}
          left={296}
          width={691}
          top={1682}
          textSize={{ width: 560, height: 110 }}
          gradient={{ sizeX: 460.08, sizeY: 977.58, atX: 345.5, atY: 86.5 }}
          flash={{ left: 665.395, top: 23 }}
        />

        <GoBackButton onClick={controller.handleGoBack} />
      </div>
    </div>
  );
}
